import type { OptionMeta, SelectValue } from './select-context';

export function upsertOption(options: OptionMeta[], meta: OptionMeta): OptionMeta[] {
	const existingIndex = options.findIndex((o) => o.value === meta.value);
	return existingIndex === -1
		? [...options, meta]
		: options.map((o, i) => (i === existingIndex ? meta : o));
}

export function removeOption(options: OptionMeta[], value: SelectValue): OptionMeta[] {
	return options.filter((o) => o.value !== value);
}

export function getFirstEnabledIndex(options: { disabled: boolean }[]): number {
	return options.findIndex((o) => !o.disabled);
}

export function getLastEnabledIndex(options: { disabled: boolean }[]): number {
	for (let i = options.length - 1; i >= 0; i -= 1) {
		if (!options[i].disabled) {
			return i;
		}
	}
	return -1;
}

export function getNextIndex(
	options: { disabled: boolean }[],
	currentIndex: number,
	direction: 1 | -1
): number {
	if (options.length === 0 || options.every((o) => o.disabled)) {
		return -1;
	}
	let index = currentIndex;
	for (let step = 0; step < options.length; step += 1) {
		index = (index + direction + options.length) % options.length;
		if (!options[index].disabled) {
			return index;
		}
	}
	return -1;
}

export function matchTypeahead(
	options: { label: string; disabled: boolean }[],
	query: string,
	currentIndex: number
): number {
	if (!query || options.length === 0) {
		return -1;
	}
	const lowerQuery = query.toLowerCase();
	for (let step = 1; step <= options.length; step += 1) {
		const index = (currentIndex + step) % options.length;
		const option = options[index];
		if (!option.disabled && option.label.toLowerCase().startsWith(lowerQuery)) {
			return index;
		}
	}
	return -1;
}

export function formatDisplayLabel(selectedLabels: string[], placeholder: string): string {
	return selectedLabels.length === 0 ? placeholder : selectedLabels.join(', ');
}

let instanceCounter = 0;
export function nextSelectInstanceId(): string {
	instanceCounter += 1;
	return `select-${instanceCounter}`;
}

export function optionDomId(idPrefix: string, value: SelectValue): string {
	return `${idPrefix}-option-${String(value)}`;
}
